import { Container, Col, Row } from "reactstrap";
import * as DomainQL from "queries/domain";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list";
import DomainSchema from "@common/schema/domain/public";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.domains"}
        query={DomainQL.list}
        variables={params}
        schema={DomainSchema}
        target={{ $ref: "/Public/Domain" }}
        config={{
          "/Public/Domain": {
            fields: ["domain", "createdAt"],
          },
        }}
        content={({ item: { domain } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${domain}/`}>
              View 
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
